import React from 'react';

const SkillList = (props) => {
    return (
        <>


            <ul className="fa-ul mb-0">
                {props.texts.map((e, index) => (

                    <li key={index}>

                        <span className="fa-li"><i className="fas fa-check"></i></span>
                        {e}
                    </li>
                ))}


            </ul>
        </>
    );
};

export default SkillList;